import {
  GET_VEHICLE_STATUSES,
  GET_SUMMARY_TRIP,
  GET_RAW_ALERTS,
  GET_VEHICLE_STATUS,
} from '@/services/api/fleet'

import { client } from '@/services/apolloclient'

import moment from 'moment'

moment.locale('id')

export const state = {
  fleets: [],
  vehicleId: [],
  vehicleIdCompany: [],
  Notification: [],
  lastDataHistory: [],
  dataHistory: {
    licensePlate: null,
    imei: null,
    vehicleId: null,
    driver: null,
    direction: null,
    calculatedMotionStatus: null,
    tripstartOn: null,
    lastPacket: null,
    latitude: null,
    longitude: null,
    totalHourStop: null,
    icon: null,
  },
  loadingKendaraan: false,
  loadingHistory: false,
  autoReload: true,
  fleetTrafficControl: true,
  fleetCluster: true,
  markerAll: true,
  markerPlate: true,
  markerPlateLabel: true,
  markerHull: true,
  markerDriver: true,
  markerGps: true,
  markerLabel: true,
  markerLabelLayout: true,
  geoStatus: true,
  geoCluster: true,
  mapMode: 'roadmap',
  speedChartStatus: false,
  speedChart: {
    category: [],
    data: [],
  },

  vehicleStatus: [],
}

export const getters = {
  fleetsListFilter: (state) => (search) => {
    if (!search) {
      return state.fleets || []
    }

    return state.fleets.filter(
      (fleet) =>
        fleet.licensePlate.toLowerCase().match(search.toLowerCase()) ||
        (fleet.vehicle.driver1
          ? fleet.vehicle.driver1.fullname.toLowerCase().match(search.toLowerCase())
          : null)
    )
  },
  fleetsList: (state) => state.fleets || [],

  notificationsListFilter: (state) => (search) => {
    if (!search) {
      return state.Notification || []
    }

    return state.Notification.filter(
      (notif) =>
        notif.vehicle.licensePlate.toLowerCase().match(search.toLowerCase()) ||
        (notif.driver != null
          ? notif.driver.fullname.toLowerCase().match(search.toLowerCase())
          : null)
    )
  },
  notificationsList: (state) => state.Notification || [],

  geoList: (state) => state.Geofence || [],
  geoListFilter: (state) => (search) => {
    if (!search) {
      return state.Geofence || []
    }
    return state.Geofence.filter((fleet) =>
      fleet.name_geo.toLowerCase().match(search.toLowerCase())
    )
  },

  lastHistoryList: (state) => state.lastDataHistory || {},
}

export const actions = {
  setHistory({ commit }, payload) {
    commit('SET_HISTORY', payload)
  },

  async requestFleets({ commit, dispatch }, payload) {
    await client
      .query({
        client: 'clientLowPrio',
        query: GET_VEHICLE_STATUSES,
        variables: payload.filter,
        fetchPolicy: 'no-cache',
      })
      .then((response) => {
        if (response.data.vehicleStatuses.isSuccessful) {
          var vehicles = response.data.vehicleStatuses.vehicleStatuses

          if (payload.plate != '') {
            const fleet = vehicles.filter((fleet) => fleet.licensePlate == payload.plate)

            if (
              payload.latLng.lat != fleet[0]['latitude'] &&
              payload.latLng.lng != fleet[0]['longitude']
            ) {
              const data = {
                zoom: 15,
                open: true,
                gmp: fleet[0],
                type: 'fleet',
              }

              dispatch(
                'map/requestAddress',
                {
                  lat: fleet[0]['latitude'],
                  lng: fleet[0]['longitude'],
                },
                { root: true }
              )

              dispatch('map/setCENTER', data, { root: true })
            }
          }

          commit('setFleets', vehicles)
        }
      })
  },

  async requestNotifications({ state, commit, rootState }, payload) {
    const date = {
      startDate: moment(`${moment().format('YYYY-MM-DD')} 00:00:00`).toISOString(),
      endDate: moment(`${moment().format('YYYY-MM-DD')} 23:59:59`).toISOString(),
    }
    let alertCodes = [
      1, 11, 17, 18, 8, 23, 24, 3, 10, 12, 7, 16, 15, 21, 22, 49, 51, 52, 53, 54, 55, 56, 62, 63,
      75,
    ]
    if (rootState.identity.whoami?.scopes.includes('seat_belt_alert:read')) {
      alertCodes.push(110)
    }
    if (rootState.identity.whoami?.scopes.includes('raw_alerts_adas:read')) {
      alertCodes = alertCodes.concat([90, 91, 92])
    }
    if (rootState.identity.whoami?.scopes.includes('e1f-web-excessivestopinsidegeofence:read')) {
      alertCodes = alertCodes.concat([104])
    }
    if (rootState.identity.whoami?.scopes.includes('teltonika-device:read')) {
      alertCodes = alertCodes.concat([94, 95])
    }
    if (rootState.identity.whoami?.scopes.includes('fatigue_driving_alert:read')) {
      alertCodes.push(50)
    }
    if (rootState.identity.whoami?.scopes.includes('infrared_blocked_alert:read')) {
      alertCodes.push(111)
    }
    if (rootState.identity.whoami?.scopes.includes('front_object_detected_alert:read')) {
      alertCodes.push(113)
    }

    // const date = {
    //   startDate: moment(`${moment().format('YYYY-MM-DD')} 00:00:00`).toISOString(),
    //   endDate: moment(`${moment().format('YYYY-MM-DD')} 23:59:59`).toISOString()
    // }

    await client
      .query({
        client: 'clientLowPrio',
        query: GET_RAW_ALERTS,
        variables: {
          filter: {
            alertCode: alertCodes,
            startDate: date.startDate,
            endDate: date.endDate,
            pagination: {
              page: 1,
              show: 50,
            },
            orderBy: [JSON.stringify({ createdOn: 'desc' })],
            vehicleId: state.vehicleIdCompany,
            ...(payload?.isLiveView ? { isLiveView: true } : {}),
          },
        },
        fetchPolicy: 'no-cache',
      })
      .then((data) => {
        if (data.data.rawAlerts.isSuccessful) {
          let alerts = data.data.rawAlerts.rawAlerts.data
          commit('setNotifications', alerts)
        }
      })
  },

  async requestFleetHistory({ commit }, payload) {
    const response = await client.query({
      query: GET_SUMMARY_TRIP,
      fetchPolicy: 'no-cache',
      variables: {
        filter: payload,
      },
    })

    if (response.data.summaryTrips.isSuccessful) {
      if (response.data.summaryTrips.summaryTrips.summaryTrips.length) {
        commit('setFleetHistory', response.data.summaryTrips.summaryTrips)
      } else {
        commit('setFleetHistory', { summaryTrips: [] })
      }
    } else {
      commit('setFleetHistory', { summaryTrips: [] })
    }
  },

  async requestVehicleStatus({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      client
        .query({
          query: GET_VEHICLE_STATUS,
          variables: {
            filter: payload.filter,
          },
          fetchPolicy: 'no-cache',
        })
        .then((response) => {
          if (response.data.vehicleStatus.isSuccessful) {
            const vehicleStatus = response.data.vehicleStatus.vehicleStatus

            commit('setVehicleStatus', vehicleStatus)
            resolve(vehicleStatus)
          }
        })
    })
  },
}

export const mutations = {
  ORDER_BY(state, payload) {
    if (payload.type === 'date') {
      if (payload.order === 'asc') {
        state.fleets = state.fleets.sort(
          (a, b) => new Date(a[payload.objName]) - new Date(b[payload.objName])
        )
      } else {
        state.fleets = state.fleets.sort(
          (a, b) => new Date(b[payload.objName]) - new Date(a[payload.objName])
        )
      }
    } else {
      if (payload.order === 'asc') {
        state.fleets = state.fleets.sort((a, b) =>
          a[payload.objName] > b[payload.objName]
            ? 1
            : b[payload.objName] > a[payload.objName]
            ? -1
            : 0
        )
      } else {
        state.fleets = state.fleets.sort((a, b) =>
          b[payload.objName] > a[payload.objName]
            ? 1
            : a[payload.objName] > b[payload.objName]
            ? -1
            : 0
        )
      }
    }
  },

  SET_HISTORY(state, payload) {
    state.dataHistory.hullNo = payload.hullNo
    state.dataHistory.type = payload.type
    state.dataHistory.category = payload.category
    state.dataHistory.licensePlate = payload.licensePlate
    state.dataHistory.imei = payload.imei
    state.dataHistory.vehicleId = payload.vehicleId
    state.dataHistory.driver = payload.driver
    state.dataHistory.direction = payload.direction
    state.dataHistory.calculatedMotionStatus = payload.calculatedMotionStatus
    state.dataHistory.tripDrivetime = payload.tripDrivetime
    state.dataHistory.tripDistance = payload.tripDistance
    state.dataHistory.tripstartOn = payload.tripstartOn
    state.dataHistory.lastPacket = payload.lastPacket
    state.dataHistory.latitude = payload.latitude
    state.dataHistory.longitude = payload.longitude
    state.dataHistory.icon = payload.icon
    state.dataHistory.lastPositionStatus = payload.lastPositionStatus
  },

  RESET_HISTORY(state) {
    state.lastDataHistory.summaryTrips.splice(0, state.lastDataHistory.summaryTrips.length)
    state.dataHistory = {
      licensePlate: null,
      imei: null,
      vehicleId: null,
      driver: null,
      direction: null,
      calculatedMotionStatus: null,
      tripstartOn: null,
      lastPacket: null,
      latitude: null,
      longitude: null,
      totalHourStop: null,
      icon: null,
    }
  },

  SET_ADDRESS(state, payload) {
    state.Notification[payload.index].addressByMap = payload.address
  },

  setFleets(state, payload) {
    state.fleets = payload
  },

  setVehicleID(state, payload) {
    state.vehicleId = payload
  },

  setVehicleIdCompany(state, payload) {
    state.vehicleIdCompany = payload
  },

  setNotifications(state, payload) {
    state.Notification = payload
  },

  setFleetHistory(state, payload) {
    state.lastDataHistory = payload
  },

  sortFleetHistory(state) {
    state.lastDataHistory.summaryTrips.reverse()
  },

  addTripDetail(state, payload) {
    state.lastDataHistory.summaryTrips[payload.index] = {
      ...state.lastDataHistory.summaryTrips[payload.index],
      details: payload.detail,
    }
  },

  loadingKendaraan(state, payload) {
    state.loadingKendaraan = payload
  },

  loadingHistory(state, payload) {
    state.loadingHistory = payload
  },

  autoReload(state, payload) {
    state.autoReload = payload
  },

  fleetTrafficControl(state, payload) {
    state.fleetTrafficControl = payload
  },

  fleetCluster(state, payload) {
    state.fleetCluster = payload
  },

  geoStatus(state, payload) {
    state.geoStatus = payload
  },

  geoCluster(state, payload) {
    state.geoCluster = payload
  },

  speedChart(state, payload) {
    state.speedChart.category = payload.category
    state.speedChart.data = payload.data
  },

  speedChartStatus(state) {
    state.speedChartStatus = !state.speedChartStatus
  },

  markerAll(state, payload) {
    state.markerAll = payload
  },

  markerPlate(state, payload) {
    state.markerPlate = payload
  },

  markerPlateLabel(state, payload) {
    state.markerPlateLabel = payload
  },

  markerHull(state, payload) {
    state.markerHull = payload
  },

  markerDriver(state, payload) {
    state.markerDriver = payload
  },

  markerGps(state, payload) {
    state.markerGps = payload
  },

  markerLabel(state, payload) {
    state.markerLabel = payload
  },

  mapMode(state, payload) {
    state.mapMode = payload
  },

  markerLabelLayout(state, payload) {
    state.markerLabelLayout = payload
  },

  setVehicleStatus(state, payload) {
    state.vehicleStatus = payload
  },
}
